import { defineChatViewActions } from './actionsContext'

export const reactionActions = defineChatViewActions({
  setLastMessageReaders(readers: any[]): void {
    this.lastMessageReaders = readers
  },

  clearLastMessageReaders(): void {
    this.lastMessageReaders = null
  },

  transformCoreReactions(rawReactions: any[] = []) {
    return rawReactions.map(reaction => ({
      id: reaction.id,
      user_id: reaction.user || reaction.user_id || '',
      reaction_type_id: reaction.reaction_type || reaction.reaction_type_id || '',
      matrix_emoji_key: reaction.matrix_emoji_key,
      user_name: reaction.user_name,
      avatar: reaction.avatar,
      created_at: reaction.created_at,
    }))
  },

  reactionsAreEqual(left: any[] = [], right: any[] = []): boolean {
    if (left.length !== right.length) {
      return false
    }

    return left.every((reaction, index) => {
      const other = right[index]
      if (!other) {
        return false
      }

      return String(reaction.user_id || '') === String(other.user_id || '')
        && String(reaction.reaction_type_id || '') === String(other.reaction_type_id || '')
        && String(reaction.matrix_emoji_key || '') === String(other.matrix_emoji_key || '')
    })
  },

  /**
   * 3b.1: ChatLog читает реакции из core.messages — зеркало в activeChat не нужно.
   */
  patchMessageReactionsInActiveChat(_messageId: number | string): void {
    // no-op
  },

  syncMessageReactionsFromCore(): void {
    // no-op
  },
})
